import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function() {
	return useFetchData({ 
		APIMethod: API.getAllCategories, 
		cache_name: "all_categories"
	})
}